module.exports = __webpack_public_path__ + "fonts/Raleway-Light.45e75ce1.woff2";